import React from 'react';
import PropTypes from 'prop-types';
import logger from './utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    if (window.__ENV.REACT_APP_ENV === 'local') {
      return { hasError: true, error };
    }
    return { hasError: false, error };
  }

  componentDidCatch(error, errorInfo) {
    const errorMessage = `${error?.name || ''} ${error?.message || ''}`.trim();
    const isNotafunctionError = /is not a function/i.test(errorMessage);
    const errorMeta = {
      errorName: error?.name,
      errorMessage: error?.message,
      // errorStack: error?.stack,
      componentStack: errorInfo?.componentStack,
    };

    if (isNotafunctionError) {
      const genesysRuntimeDiag = window.__GENESYS_RUNTIME_DIAG || null;
      logger.error(
        {
          ...errorMeta,
          route: window.location.pathname,
          query: window.location.search,
          genesysRuntimeDiag,
        },
        'Error caught in ErrorBoundary:',
      );
    } else {
      logger.error(errorMeta, 'Error caught in ErrorBoundary:');
    }
    this.setState({ errorInfo });
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div>
          <h1>Something went wrong!</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {error && error.toString()}
            <br />
            {errorInfo?.componentStack}
          </details>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
